import { httpGet, httpPost, httpDelete } from "@/request/http";

let path = "/deviceuvs";

export default {
  gets() {
    return httpGet(`${path}/lists`);
  },
  postDevices(businessId, deviceIds, productType) {
    return httpPost(`${path}/adddevices`, {
      BusinessId: businessId,
      DeviceUVIds: deviceIds,
      ProductType: productType,
    });
  },
  getKDSs() {
    return httpGet(`${path}/kdsServers`);
  },
  postKDSs(businessId, deviceIds) {
    return httpGet(`${path}/kdsServers`, {
      BusinessId: businessId,
      DeviceUVIds: deviceIds,
    });
  },
};
